
import { defineComponent } from 'vue'
import UI_Loader from '@/components/UI/Loader/Loader.vue'

export default defineComponent({
  name: 'PageView_Main',
  components: {
    UI_Loader
  },
  methods: {
    handleFiles: function (event: any) {
      const files = event.target!.files
      console.log(files)
      files.forEach((file: File, index: number) => {
        setTimeout(() => {
          this.$store.dispatch('sharedStateModule/CreateNewFile', file)
        }, 500 * index)
      })
    },
    uploadFiles: function () {
      const element: HTMLInputElement = document.querySelector('#fileItem')! as HTMLInputElement
      element.value = ''
      element.click()
    },
    DeleteFile: function (fileID: string) {
      this.$store.dispatch('sharedStateModule/DeleteCreatedFile', fileID)
    },
    CancelFile: function (fileID: string, progress: number) {
      if (progress === -1) {
        console.log('Cannot cancel from remote')
      } else {
        this.$store.commit('sharedStateModule/UpdateFileStatus', {
          fileID: fileID,
          status: 'Cancelling',
          progress: -1
        })
        this.$store.commit('sharedStateModule/RemoveWorker', fileID)
        setTimeout(() => {
          this.$store.dispatch('sharedStateModule/DeleteCreatedFile', fileID)
        }, 2500)
      }
    },
    DownloadFile: function (fileID: string) {
      this.$store.dispatch('sharedStateModule/DownloadFile', fileID)
    }
  },
  computed: {
    files: function () {
      const rev: Array<any> = []
      Object.entries(this.$store.getters['sharedStateModule/getSharedFileList']).forEach((el: [string, any]) => {
        rev.unshift({
          id: el[0],
          name: el[1].name,
          icon: el[1].icon,
          size: el[1].humansize,
          status: el[1].status,
          progress: Math.round(el[1].progress),
          isFullyDatarised: (el[1].data[0] !== undefined),
          isUploader: el[1].local
        })
      })
      return rev
    }
  }
})
